import styled from 'styled-components';

const DialogActions = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 7px 24px 22px;
`;

export default DialogActions;
